export default __webpack_public_path__ + "static/media/full-screen.6a9f9a39.svg";